import { createContext } from 'react';
import { StepItemContextValue, StepperContextValue } from '../types';

export const StepperContext = createContext<StepperContextValue | undefined>(undefined);

export const StepItemContext = createContext<StepItemContextValue | undefined>(undefined);
